<template>
  <div>
    <div v-if="!!currentNavObj.routeForButton">
      <router-link :to="currentNavObj.routeForButton">
        <md-button class="md-header-btn md-header-tab-btn">
          {{ $t(`views.admin.dashboard.${currentNavObj.translationParameter}.button.add.label`) }}
        </md-button>
      </router-link>
    </div>
    <div v-else>
      <md-button class="md-header-btn md-header-tab-btn" @click="currentNavObj.alternateCallback">
        {{ $t(currentNavObj.alternateTranslationPath) }}
      </md-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "NavigationTabButtons",
  computed: {
    ...mapGetters("misc", ["currentNavObj"])
  }
}
</script>
<style lang="scss" scoped>
.custom-nav-button-style {
  height: 40px;
  position: absolute;
  right: 72px;
  top: 135px;
}

.button {
  width: 205px;
  font-size: 10px;
}
</style>
